import React from 'react';
import { motion } from 'framer-motion';
import { PageHero } from '../../components/PageHero';
export function BoardPage() {
  const boardMembers = [{
    name: 'Alexander Chen',
    title: 'Chairman of the Board',
    bio: 'With over 30 years in global hospitality, Alexander guides the strategic vision of JJ Group. He previously served as CEO of a major international hotel brand.',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=800&q=80'
  }, {
    name: 'Sarah Jenkins',
    title: 'Lead Independent Director',
    bio: 'Sarah brings deep expertise in real estate acquisition and corporate governance, ensuring sustainable growth across all our portfolios.',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&q=80'
  }, {
    name: 'Marcus Thorne',
    title: 'Director, Investment Strategy',
    bio: 'A veteran in private equity, Marcus oversees the financial health and expansion strategies for our advisory and investment arms.',
    image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=800&q=80'
  }, {
    name: 'Elena Rostova',
    title: 'Director, Culinary Innovation',
    bio: 'Elena ensures our concepts remain authentic yet innovative. She has authored several books on Central Asian cuisine and culture.',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=800&q=80'
  }];
  return <div className="bg-white" data-id="element-430">
      <PageHero title="Board of Directors" subtitle="Guiding our vision with decades of global expertise." data-id="element-431" />

      <section className="py-24 md:py-32" data-id="element-432">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-433">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-434">
            {boardMembers.map((member, index) => <motion.div key={index} className="group relative overflow-hidden bg-brand-gray/10" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} data-id="element-435">
                <div className="aspect-[3/4] relative overflow-hidden" data-id="element-436">
                  <img src={member.image} alt={member.name} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700" data-id="element-437" />
                  <div className="absolute inset-0 bg-gradient-to-t from-brand-dark via-brand-dark/20 to-transparent opacity-80" data-id="element-438"></div>

                  {/* Hover Bio Overlay */}
                  <div className="absolute inset-0 bg-brand-red/95 p-8 flex flex-col justify-center translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out" data-id="element-439">
                    <p className="text-white/90 font-light leading-relaxed text-sm" data-id="element-440">
                      {member.bio}
                    </p>
                  </div>

                  <div className="absolute bottom-0 left-0 right-0 p-6 z-10 group-hover:opacity-0 transition-opacity duration-300" data-id="element-441">
                    <h3 className="text-2xl font-serif text-white mb-1" data-id="element-442">
                      {member.name}
                    </h3>
                    <p className="text-brand-gold text-xs uppercase tracking-[0.1em]" data-id="element-443">
                      {member.title}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
    </div>;
}